import { store, storeEmitter, INITIAL_DATA } from "./store";
import { USER_AUTHORIZED_USER } from "../components/RedbayComponents";

export default {
  init() {
    console.log("init listener");
    storeEmitter.on(INITIAL_DATA, shop => {
      store.dispatch("user/setUser", shop.user);
    });

    storeEmitter.on(USER_AUTHORIZED_USER, user => {
      if (user) {
        if (user.level.id != 21) {
          store.dispatch("user/getUserSettings");
          store.dispatch("user/getPrices");
          // store.dispatch("company/settings");
        }
      }
    });

    storeEmitter.on("notification", params => {
      console.log("SUCCESS");
    });
  }
};



// WEBPACK FOOTER //
// ./src/state/listener.js